export const SELECTION_FORM = "SelectionForm";
export const SELECTION_FORM_SELECT = "SelectionFormSelect";
export const SELECTION_FORM_CHECK = "SelectionFormCheck";
export const SELECTION_FORM_LABEL = "SelectionFormLabel";
export const SELECTION_FORM_ITEM = "SelectionFormItem";
export const SELECTION_FORM_MENU_ITEM = "SelectionFormMenuItem";
